// Module
var code = "<div class=\"body\" :class=\"{'is-mobile' : isMobile}\"> <main-header/> <header-error/> <div id=\"wrapper\"> <main-menu/> <div class=\"page-content-wrapper\"> <router-view/> </div> </div> <modal-message/> <loading/> <main-footer/> </div>";
// Exports
export default code;